module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1029-282ead8d9a34a9595720e2c066fb9f99.png";